import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import { VueEditor } from 'vue2-editor'
import { Api, Toast } from './../../../../services'
import WidgetTermsOfUse from './../../Widget/TermsOfUse.vue'

export default {
  name: 'ProductAdd',
  props: [],
  components: {
    Header,
    ProgressHUD,
    VueEditor,
    WidgetTermsOfUse,
  },
  data() {
    return {
      product: {
        name: '',
        description: '',
        rangePrices: '',
        type: 'Service',
        phone: '',
        email: '',
        country: '',
        region: '',
        images: null,
        draft: false,
      },
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
      isAcceptTerms: false,
      isOpenModalOnlyTerms: false,
      validationMessage: '',
      fromRangePrice: null,
      toRangePrice: null,
      numbers: {},
      countries: {},
      selectCountry: null,
      draft: false,
    }
  },  
  methods: {    
    setHeightImage() {
      var pic_box = $('.picture-box')
      if (pic_box && pic_box[0]) {
        var h = document.getElementById('content').clientHeight
        pic_box[0].style.height =
          (h > screen.availHeight ? h - 80 : screen.availHeight - 80) + 'px'
      }
    },

    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize(event) {
      this.setHeightImage()
    },

    saveDraftService() {      
      this.draft = true;
      this.saveProduct();
    },

    async saveProduct() {   

      try {
        if (!this.draft) {
          let isValid = await this.$validator.validateAll('firstForm')
          if (
            !isValid ||
            !this.editorIsNotEmpty(this.product.description) ||
            !this.rangeIsNotEmpty(this.$refs.fromRangePrice.value, this.$refs.toRangePrice.value)
          ) {
            Toast.validationFieldsError({ toast: this.$toast })
            return
          }     
        }
        else {          
          if (this.product.name == "") {
            Toast.validationFieldsError({ toast: this.$toast })
          }
        }  
        if (this.isAcceptTerms == false) {
          $('#modalTermsAndConditions').modal('open')
          return
        }

        this.$refs.progress.show()

        this.product.rangePrices = this.fromRangePrice + "-" + this.toRangePrice        

        var formData = new FormData()
        for (var key in this.product) {
          if (String(key) == 'images') break

          formData.append(key, this.product[key])
        }

        // Append images to formData
        if(this.product.images)
          for (
            var index = 0;
            !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
            index++
          ) {
            formData.append('files' + index, this.product.images[index])
          }

        formData.append('draft', this.draft)
          
        var response = await Api.createService(formData)
        this.$router.push('/service/' + response.data.product._id)
      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      this.product.images = files

      if (this.product.images.length >= 5) {
        this.$toast.error({
          title: 'Error',
          message: 'You can upload up to five images',
          color: '#BD362F',
        })
      }
    },

    editorIsNotEmpty: function(html) {
      if (this.strip(html) == '') {
        return false
      }

      return true
    },

    rangeIsNotEmpty: function(from, to) {
      if (from == '' || to == '' || from > to) {
        return false
      }

      return true
    },

    strip: function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html')
      return doc.body.textContent || ''
    },

    acceptTerms() {
      this.isAcceptTerms = true

      if (this.isOpenModalOnlyTerms == false) {
        this.saveProduct()
      }
    },

    notAcceptTerms() {
      this.isAcceptTerms = false
    },
  },
  created() {
    this.countries = require('./../../../../data/country.js')
    for(var i=0; i<1001; i++)
      this.numbers[i] = i;
  },
  mounted() {
    
    var _s = this
    this.$refs.selectCountry.onchange = function(){ 
      _s.product.country = this.value;
    }
    this.$refs.fromRangePrice.onchange = function(){ 
      _s.fromRangePrice = this.value;
    }
    this.$refs.toRangePrice.onchange = function(){ 
      _s.toRangePrice = this.value;
    }

    $('select').material_select()
    this.setHeightImage()

    $('.modal').modal({
      dismissible: true,
      opacity: 0.5,
      inDuration: 300,
      outDuration: 200,
      startingTop: '4%',
      endingTop: '10%',
      ready: function(modal, trigger) {},
      complete: function() {
        this.isOpenModalOnlyTerms = false
      },
    })

    $('#materialSelect').material_select()
    this.setHeightImage()

    window.addEventListener('resize', this.handleResize)
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Services/Add/ServicesAdd.component.js